// extracted by mini-css-extract-plugin
export default {"root":"wj_BKd"};